import { Link } from 'react-router';

import { MenuItem } from '@chakra-ui/react';

import type { NavMenuItemProps } from './types/nav-menu-item.props';

const NavMenuItem = ({ children, icon, isDisabled, onClick, to }: NavMenuItemProps) => {
  return (
    <MenuItem
      _hover={{ bg: 'hsp.500', color: 'white' }}
      as={Link}
      icon={icon}
      isDisabled={isDisabled}
      onClick={onClick}
      p={3}
      to={to}>
      {children}
    </MenuItem>
  );
};

export default NavMenuItem;
